// eslint-disable-next-line import/no-cycle
import { COMMON_URL } from "../system";
import responseHandler from "../system/server-response-handler";
import { getRequest, postRequest } from "../system/server-call";

/**
 * The Event Booking Service
 *
 * This is used for getting data from server and handling the business logic on that data
 */

// get shot list based on event type
const getShotList = (id) => {
  return getRequest(
    `/api/v1/User/EventSetup/GetEventTypeItems/${id}`,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

// get shutter Bs list
const getAvailableShutterBs = (data) => {
  return postRequest(
    "/api/v1/ShutterB/GeoLocation/GetSBByLocation",
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const checkOut = (data) => {
  return postRequest(`/api/Stripe/CreateCheckoutSession`, data).then(
    (response) => response.data,
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const requestBooking = (data, orderItemGroupId, CheckoutStatus) => {
  return postRequest(
    `/api/Stripe/MakePayment/${data}/${orderItemGroupId}/${CheckoutStatus}`,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getReelPrice = () => {
  return getRequest("/api/v1/user/reel/getprice", false).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getMiscAmounts = () => {
  return getRequest("/api/v1/user/userinfo/getconfiguration", false).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const applyDiscount = (dateToSend) => {
  return postRequest(`/api/v1/admin/PromoCodes/ApplyDiscount`, dateToSend).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const draftEventDetails = (data) => {
  return postRequest(`/api/v1/User/EventSetup/EventSaveAsDraft`, data).then(
    (response) => response.data,
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

// Get the draft event list according to groupEventId
const getDraftEvents = (eventGroupId) => {
  return responseHandler.processServerCallResponse(
    getRequest(
      `${COMMON_URL.USER}/EventSetup/GetDraftEvents/${eventGroupId}`,
      false
    )
  );
};

const getReelTypes = () => {
  return getRequest(`/api/v1/User/EventSetup/getReelTypes`, false).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const uploadMusicFile = (formData) => {
  return postRequest(
    "/api/v1/User/EventSetup/UploadMusicFile",
    formData,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

// Get Event Type shot list
const getEventTypeShotList = (body) => {
  return postRequest("/api/v1/User/EventSetup/GetEventTypeShotList", body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

// Get edit brief
const getEditBrief = (body) => {
  return postRequest("/api/v1/User/EventSetup/GetEditBrief", body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

// Get the recap types (Storytelling & Highlight)
const getRecapTypes = () => {
  return responseHandler.processServerCallResponse(
    getRequest(`${COMMON_URL.ADMIN}/reel/GetReelModeConfigurations`, false)
  );
};

const getAvailableShutterb = (eventId, token) => {
  return getRequest(
    `/api/v1/User/EventSetup/GetAvailableShutterb/${eventId}/${token}`,
    false
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const assignShutterb = (data) => {
  return postRequest(
    "/api/v1/User/EventSetup/AssignShutterb",
    data,
    false
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const notifyAdminToAssignShutterb = (eventId, orderItemId) => {
  return postRequest(
    `/api/v1/User/EventSetup/NotifyAdminToAssignShutterb/${eventId}/${orderItemId}`,
    {},
    false
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

// Get the edit events list according to groupEventId and eventId
const getEditEvents = (eventGroupId, eventId, isAddUpdateRecap) => {
  const url = eventId
    ? `${COMMON_URL.USER}/EventSetup/GetEventsToEdit/${eventGroupId}/${isAddUpdateRecap}/${eventId}`
    : `${COMMON_URL.USER}/EventSetup/GetEventsToEdit/${eventGroupId}/${isAddUpdateRecap}`;

  return responseHandler.processServerCallResponse(getRequest(url, true));
};

const getTaxForLocation = (dateToSend) => {
  return postRequest("/api/Stripe/GetTaxForLocation", dateToSend).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

// exporting functions for other files
export const eventBookingServices = {
  checkOut,
  getShotList,
  applyDiscount,
  getReelPrice,
  getReelTypes,
  getEditBrief,
  getEditEvents,
  getRecapTypes,
  requestBooking,
  getMiscAmounts,
  getDraftEvents,
  uploadMusicFile,
  draftEventDetails,
  getEventTypeShotList,
  getAvailableShutterBs,
  getAvailableShutterb,
  assignShutterb,
  notifyAdminToAssignShutterb,
  getTaxForLocation,
};
